<div class="">
  <div class="cooking-header">
    <div class="title">
      <img src="assets/cookingbook/users.svg" alt="" />

      <p>افراد خانه</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="mb-40">
    <p class="title-members">این لیست با افراد خانه مشترک است.</p>
    <ng-container>
      <div class="member">
        <img
          class="profile"
          [src]="getProfile(home?.owner)"
          [ngClass]="{ active: isMe(home?.owner._id) }"
          alt=""
        />
        <div>
          <p>
            {{ home?.owner.name }}

            <span *ngIf="isMe(home?.owner._id)"> (من)</span>
          </p>
          <span class="admin">مدیر خانه</span>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let member of home.members">
      <div class="member">
        <img
          class="profile"
          [src]="getProfile(member.user)"
          [ngClass]="{ active: isMe(member.user._id) }"
          alt=""
        />
        <div>
          <p>
            {{ member.user.name }}
            <span *ngIf="isMe(member.user._id)"> (من)</span>
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</div>
